export enum PaymentStatus {
    AUTH = 'AUTH',
    CANCEL = 'CANCEL',
    REFUND = 'REFUND',
    PEND = 'PEND',
    RECEIVED = 'RECEIVED',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    CANCELLED = 'CANCELLED',
    AUTOCANCELLED = 'AUTOCANCELLED',
    RESEND = 'RESEND',
    UNKNOWN = 'UNKNOWN',
    FAILURE = 'FAILURE',
    ABORTED = 'Aborted',
    MESSAGE_FORMAT = 'MessageFormat',
    IN_PROGRESS = "InProgress"
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/payment-status.enum.ts